var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#1e1e1e",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.75C1.3375 13.75 0.98425 13.6033 0.69025 13.3097C0.39675 13.0157 0.25 12.6625 0.25 12.25V1.75C0.25 1.3375 0.39675 0.98425 0.69025 0.69025C0.98425 0.39675 1.3375 0.25 1.75 0.25H7V1.75H1.75V12.25H12.25V7H13.75V12.25C13.75 12.6625 13.6033 13.0157 13.3097 13.3097C13.0157 13.6033 12.6625 13.75 12.25 13.75H1.75ZM5.275 9.775L4.225 8.725L11.2 1.75H8.5V0.25H13.75V5.5H12.25V2.8L5.275 9.775Z",
    fill: "#1e1e1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNew);
export default __webpack_public_path__ + "static/media/open_in_new.423fbef6.svg";
export { ForwardRef as ReactComponent };